export interface TokenSegment {
  name: string;
  value: number;
  color: string;
  breakdown?: TokenSegment[];
}

export const MAVRK_TOKEN_DISTRIBUTION: TokenSegment[] = [
  {
    name: 'Liquidity Pool',
    value: 20,
    color: '#4c1d95', // Dark purple (start)
    breakdown: [
      { name: 'Initial Liquidity Pool', value: 10, color: '#5b21b6' },
      { name: 'Post-Raise LP Seeding', value: 10, color: '#6d28d9' },
    ],
  },
  {
    name: 'Founder',
    value: 5,
    color: '#6d28d9', // Medium-dark purple
  },
  {
    name: 'Team',
    value: 10,
    color: '#7c3aed', // Medium purple
  },
  {
    name: 'Ecosystem Incentives',
    value: 20,
    color: '#8b5cf6', // Medium-light purple
    breakdown: [
      { name: 'Ink Foundation', value: 10, color: '#9d6ef7' },
      { name: 'Ecosystem Marketing & Grants', value: 10, color: '#a78bfa' },
    ],
  },
  {
    name: 'Seed Round',
    value: 5,
    color: '#a78bfa', // Light purple
  },
  {
    name: 'Series A',
    value: 10,
    color: '#c4b5fd', // Lighter purple
  },
  {
    name: 'Series B',
    value: 10,
    color: '#ddd6fe', // Very light purple
  },
  {
    name: 'Series C',
    value: 20,
    color: '#ede9fe', // Lightest purple (end)
  },
];

export const TOTAL_SUPPLY = 1_000_000_000; // 1 billion MAVRK

